import { Case } from 'change-case-all';
import { emptyAsNull } from '@/lib/isNullOrEmpty.ts';
import { RuntimeConfigValue } from '@/RuntimeConfigValue.ts';

export interface RuntimeConfig {
  readonly AppVersion: RuntimeConfigValue;
  readonly BuildDate: RuntimeConfigValue;
  readonly ApiBaseUrl: RuntimeConfigValue;
  readonly MsalEnabled: RuntimeConfigValue;
  readonly MsalClientId: RuntimeConfigValue;
  readonly MsalTenantId: RuntimeConfigValue;
  readonly MsalScopes: RuntimeConfigValue;
}

const getEnv = (key: keyof RuntimeConfig): RuntimeConfigValue => {
  return new RuntimeConfigValue(key, () => {
    const envKey = Case.constant(`vite${key}`) as keyof ImportMetaEnv;
    const runtimeValue = emptyAsNull(
      globalThis.APP_CONFIG?.[key as keyof typeof globalThis.APP_CONFIG],
    );
    const buildTimeValue = emptyAsNull(import.meta.env[envKey]);
    return runtimeValue ?? buildTimeValue;
  });
};

export const runtimeConfig: RuntimeConfig = {
  AppVersion: getEnv('AppVersion'),
  BuildDate: getEnv('BuildDate'),
  ApiBaseUrl: getEnv('ApiBaseUrl'),
  MsalEnabled: getEnv('MsalEnabled'),
  MsalClientId: getEnv('MsalClientId'),
  MsalTenantId: getEnv('MsalTenantId'),
  MsalScopes: getEnv('MsalScopes'),
};
